import React, { forwardRef } from 'react';
import HBCheckbox, { HBCheckboxProps } from '../HBCheckbox/HBCheckbox';
import HBCheckboxField, {
    HBCheckboxFieldProps
} from '../HBCheckboxField/HBCheckboxField';
import useFormFieldProps, {
    FormFieldProps,
    useFormInputProps
} from './useFormFieldProps';

const HBFormCheckboxField = (props: FormFieldProps<HBCheckboxFieldProps>) => {
    const fieldProps = useFormFieldProps(props);

    return <HBCheckboxField {...fieldProps} checked={fieldProps.value} />;
};

export const FormCheckbox = forwardRef<
    HTMLInputElement,
    FormFieldProps<HBCheckboxProps>
>((props, ref) => {
    const inputProps = useFormInputProps(props);

    return <HBCheckbox {...inputProps} ref={ref} />;
});

export default HBFormCheckboxField;
